import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { InspirationComponent } from "./inspiration/inspiration.component";
import { AproposComponent } from "./apropos/apropos.component";
import { PanierComponent } from "./panier/panier.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { B2bComponent } from "./b2b/b2b.component";
import { ProductsComponent } from "./products/products.component";
import { InfoComponent } from "./info/info.component";
import { CommandesComponent } from "./commandes/commandes.component";
import { FacturesComponent } from "./factures/factures.component";
import { BalancesComponent } from "./balances/balances.component";
import { AdressComponent } from "./adress/adress.component";
import { WalletComponent } from "./wallet/wallet.component";
import { RecherchesComponent } from "./recherches/recherches.component";
import { RobimedsComponent } from "./robimeds/robimeds.component";
import { ContactComponent } from "./contact/contact.component";
import { ConnexionComponent } from "./connexion/connexion.component";
import { MarquesComponent } from "./marques/marques.component";
import { SearchComponent } from "./search/search.component";
import { MarqueComponent } from "./marque/marque.component";
import { FavorisComponent } from "./favoris/favoris.component";
import { PanierProductComponent } from "./panier-product/panier-product.component";
import { CategoryComponent } from "./category/category.component";
import { AuthGuard } from "./guard/auth.guard";
import { AuthB2cGuard } from "./guard/auth-b2c.guard";
import { IslogedGuard } from "./guard/isloged.guard";
import { ConfirmationComponent } from "./confirmation/confirmation.component";
import { FactureComponent } from "./facture/facture.component";
import { MoncompteComponent } from "./moncompte/moncompte.component";
import { CommandeDetailComponent } from "./commande-detail/commande-detail.component";
import { B2cCommandeComponent } from './b2c-commande/b2c-commande.component';
import { SeriesComponent } from './series/series.component';
import { SerieComponent } from './serie/serie.component';
import { CgvComponent } from './cgv/cgv.component';
import { PromosComponent } from './promos/promos.component';
const routes: Routes = [
  {path:'',component: HomeComponent },
  {path:'products/:id',component: ProductsComponent },
  {path:'category/:id',component: CategoryComponent },
  {path:'product-details/:id',component: ProductDetailComponent },
  {path:'inspiration', component: InspirationComponent },
  {path:'apropos',component: AproposComponent },
  {path:'checkout',component: CheckoutComponent },
  {path:'b2b',component: B2bComponent,canActivate: [AuthGuard] },
  {path:'infos',component: InfoComponent,canActivate: [AuthGuard] },
  {path:'commandes/:page',component: CommandesComponent,canActivate: [AuthGuard] },
  {path:'factures',component: FacturesComponent,canActivate: [AuthGuard] },
  {path:'balance',component: BalancesComponent,canActivate: [AuthGuard] },
  {path:'adress',component: AdressComponent,canActivate: [AuthGuard] },
  {path:'wallet',component: WalletComponent,canActivate: [AuthGuard] },
  {path:'recherches',component: RecherchesComponent },
  {path:'robimeds',component: RobimedsComponent },
  {path:'panier',component: PanierComponent},
  {path:'contact',component: ContactComponent },
  {path:'connexion',component: ConnexionComponent, canActivate: [IslogedGuard]},
  {path:'marques',component: MarquesComponent },
  {path:'series',component: SeriesComponent },
  {path:'search/:q',component: SearchComponent },
  {path:'marque/:id',component: MarqueComponent },
  {path:'serie/:id',component: SerieComponent },
  {path:'favoris',component: FavorisComponent },
  {path:'cgv',component: CgvComponent },
  {path:'confirmation',component: ConfirmationComponent},
  {path:'facture/:id',component: FactureComponent,canActivate: [AuthGuard]},
  {path:'commande-detail/:id',component: CommandeDetailComponent,canActivate: [AuthGuard]},
  {path:'commandeDetail/:id',component: B2cCommandeComponent,canActivate:[AuthB2cGuard]},
  {path:'moncompte',component: MoncompteComponent,canActivate:[AuthB2cGuard]},
  {path:'promos',component: PromosComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
